import { videoAssetFragment } from "./video-asset";

export const contentBlocksFragment = `
blocks[]{
  _type == "faqBlock" => {
    _type,
    _key,
    label,
    items[]{
      _key,
      question,
      answer,
      button{ label, href }
    }
  },
  _type == "speakerBlock" => {
    _type,
    _key,
    label,
    speakers[]->{
      _id,
      name,
      role,
      "company": companyReference->{
        _id,
        name,
        logo{
          "src": asset->url,
          "alt": asset->altText,
          "width": asset->metadata.dimensions.width,
          "height": asset->metadata.dimensions.height
        }
      },
      headshot{
        "src": asset->url,
        "alt": asset->altText,
        "width": asset->metadata.dimensions.width,
        "height": asset->metadata.dimensions.height
      },
      bio{ intro, body },
      socialLinks[]{ _key, platform, url }
    }
  },
  _type == "videoPlayerBlock" => {
    _type,
    _key,
    label,
    title,
    description,
    button{ label, href },
    assets[]->{
      ${videoAssetFragment}
    }
  },
  _type == "reference" => @->{
    _type,
    _id,
    title,
    images[]{
      "src": asset->url,
      "alt": asset->altText,
      "width": asset->metadata.dimensions.width,
      "height": asset->metadata.dimensions.height
    }
  },
  _type == "externalLinksBlock" => {
    _type,
    _key,
    label,
    title,
    links[]{
      title,
      subtitle,
      description,
      image{
        "src": asset->url,
        "alt": asset->altText,
        "width": asset->metadata.dimensions.width,
        "height": asset->metadata.dimensions.height
      },
      button{ label, href }
    }
  },
  _type == "agendaBlock" => {
    _type,
    _key,
    label,
    items[]{
      time,
      title,
      subtitle,
      description,
      speakers[]->{
        _id,
        name,
        role,
        "company": companyReference->{
          _id,
          name,
          logo{
            "src": asset->url,
            "alt": asset->altText,
            "width": asset->metadata.dimensions.width,
            "height": asset->metadata.dimensions.height
          }
        },
        headshot{
          "src": asset->url,
          "alt": asset->altText,
          "width": asset->metadata.dimensions.width,
          "height": asset->metadata.dimensions.height
        }
      }
    }
  },
  _type == "whyAttendBlock" => {
    _type,
    _key,
    label,
    sections[]{ title, description }
  },
  _type == "partnerBlock" => {
    _type,
    _key,
    label,
    items[]{
      media{
        "src": asset->url,
        "alt": asset->altText,
        "width": asset->metadata.dimensions.width,
        "height": asset->metadata.dimensions.height
      }
    }
  },
  _type == "ctaBlock" => {
    _type,
    _key,
    label,
    title,
    description,
    button{ label, href }
  },
  _type == "formBlock" => {
    _type,
    _key,
    blockUI{
      label,
      title,
      description,
      primaryCTA{ label, href },
      secondaryCTA{ label, href }
    },
    form{
      formID,
      submitButton{ label },
      successfulSubmitUI{
        title,
        description,
        primaryCTA{ label, href },
        secondaryCTA{ label, href }
      }
    }
  }
}`;
